export const CapitalizeFirstLetter = (props) => {
    let capitalizeLetter = props.wordString.charAt(0).toUpperCase() + props.wordString.slice(1).toLowerCase();
    return capitalizeLetter
}

export const IsNumeric = (str) => {
    if (typeof str != "string") return false // we only process strings!  
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}